<template>
<div class="StepThree">
    <div v-if="typeValue === 'A01'" class="type type1">
        <el-form :label-position="labelPosition" label-width="220px" :model="formType" class="animated fadeInUp">
            <el-form-item label="所处行业：">
                <el-select @change="tradeChange($event)" v-model="formType.industrycode" style="width: 320px;" placeholder="请输入">
                    <el-option v-for="(item, index) in industryData" :key="index" :label="item.text" :value="item.code"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="市盈率：">
                <el-input :onkeyup="formType.pevalue = formType.pevalue.replace(/[^\d.]/g,'')" style="width: 320px;" v-model="formType.pevalue" placeholder="根据行业自动获取" maxlength="9"></el-input>
            </el-form-item>
            <el-form-item label="净利润：">
                <!-- <el-input style="width: 320px;" v-model="formType.netprice" placeholder="请输入"></el-input> -->
                <el-input :onkeyup="formType.netprice = formType.netprice.replace(/[^\d.]/g,'')" style="width: 320px;" v-model="formType.netprice" placeholder="请输入" maxlength="8"></el-input>
                <span class="tips_span">万元</span>
            </el-form-item>
        </el-form>
    </div>
    <!-- end 市盈率估值法 -->

    <div v-if="typeValue === 'A02'" class="type type2">
        <el-form :label-position="labelPosition" label-width="220px" :model="formType" class="animated fadeInUp">
            <el-form-item label="所处行业：">
                <el-select @change="tradeChange($event)" v-model="formType.industrycode" style="width: 320px;" placeholder="请输入">
                    <el-option v-for="(item, index) in industryData" :key="index" :label="item.text" :value="item.code"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="市净率：">
                <el-input :onkeyup="formType.pbvvalue = formType.pbvvalue.replace(/[^\d.]/g,'')" style="width: 320px;" v-model="formType.pbvvalue" placeholder="根据行业自动获取" maxlength="9"></el-input>
            </el-form-item>
            <el-form-item label="净资产：">
                <el-input :onkeyup="formType.netprice = formType.netprice.replace(/[^\d.]/g,'')" style="width: 320px;" v-model="formType.netprice" placeholder="请输入" maxlength="8"></el-input>
                <span class="tips_span">万元</span>
            </el-form-item>
        </el-form>
    </div>
    <!-- end 市净率估值法 -->

    <div v-if="typeValue === 'A03'" class="type type3">
        <el-form :label-position="labelPosition" label-width="220px" :model="formType" class="animated fadeInUp">
            <el-form-item label="预测年数：">
                <el-input :onkeyup="formType.yearcount = formType.yearcount.replace(/[^\d.]/g,'')" style="width: 320px;" v-model="formType.yearcount" placeholder="输入预测年数" maxlength="3"></el-input>
                <span class="tips_span">年</span>
            </el-form-item>
            <el-form-item label="基准自由现金流：">
                <el-input :onkeyup="formType.basecashmoney = formType.basecashmoney.replace(/[^\d.]/g,'')" style="width: 320px;" v-model="formType.basecashmoney" placeholder="只输入第一年，后续年份自动计算" maxlength="8"></el-input>
                <span class="tips_span">万元</span>
                
                <el-tooltip placement="right">
                    <div class="tooltip_content" slot="content">自由现金流=税后利润+折旧-资本性支出<br>资本性支出：购建固定资产、无形资产和其他长期资<br>产支付的现金</div>
                    <img class="tooltip_icon" :src="require('@/common/images/gujingimgs/icon_tip.png')" alt="">
                </el-tooltip>

            </el-form-item>
            <el-form-item label="增长率：">
                <el-input :onkeyup="formType.insrate" style="width: 320px;" v-model="formType.insrate" placeholder="请输入" maxlength="8"></el-input>
                <span class="tips_span">%</span>
            </el-form-item>
            <el-form-item label="折现率：">
                <el-input :onkeyup="formType.disrate = formType.disrate.replace(/[^\d.]/g,'')" style="width: 320px;" v-model="formType.disrate" placeholder="请输入" maxlength="6"></el-input>
                <span class="tips_span">%</span>
                
                <el-tooltip placement="right">
                    <div class="tooltip_content" slot="content">稳定性公司9%、周期性公司12%、风险性公司15%</div>
                    <img class="tooltip_icon" :src="require('@/common/images/gujingimgs/icon_tip.png')" alt="">
                </el-tooltip>

            </el-form-item>
            <el-form-item label="永续增长率：">
                <el-input :onkeyup="formType.yxinsrate" style="width: 320px;" v-model="formType.yxinsrate" placeholder="请输入" maxlength="6"></el-input>
                <span class="tips_span">%</span>
                
                <el-tooltip placement="right">
                    <div class="tooltip_content" slot="content">可以采用国内生产总值增长率，即GDP的平均水平。</div>
                    <img class="tooltip_icon" :src="require('@/common/images/gujingimgs/icon_tip.png')" alt="">
                </el-tooltip>

            </el-form-item>
        </el-form>
    </div>
    <!-- end 现金流折现法 -->
    <div v-if="typeValue === 'A04'" class="type type4">
        <el-form :label-position="labelPosition" label-width="220px" :model="formType" class="animated fadeInUp">
            <el-form-item label="所处行业：">
                <el-select @change="tradeChange($event)" v-model="formType.industrycode" style="width: 320px;" placeholder="请输入">
                    <el-option v-for="(item, index) in industryData" :key="index" :label="item.text" :value="item.code"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="单客收入：">
                <el-input :onkeyup="formType.incomebyper = formType.incomebyper.replace(/[^\d.]/g,'')" style="width: 320px;" v-model="formType.incomebyper" placeholder="请输入" maxlength="9"></el-input>
                <span class="tips_span">元</span>
            </el-form-item>
            <el-form-item label="月活跃用户：">
                <el-input :onkeyup="formType.activeusercount = formType.activeusercount.replace(/[^\d.]/g,'')" style="width: 320px;" v-model="formType.activeusercount" placeholder="请输入" max="7"></el-input>
                <span class="tips_span">万</span>
            </el-form-item>
            <el-form-item label="用户生命周期：">
                <el-input :onkeyup="formType.lifemonth = formType.lifemonth.replace(/[^\d.]/g,'').replace('.','')" style="width: 320px;" v-model="formType.lifemonth" placeholder="请输入" max="4"></el-input>
                <span class="tips_span">月</span>
            </el-form-item>
        </el-form>
    </div>
    <!-- end 运营数据估值模型 -->
    <div v-if="typeValue === 'A05'" class="type type5">
        <el-form :label-position="labelPosition" label-width="220px" :model="formType" class="animated fadeInUp">
            <el-form-item label="团队评价：">
                <el-input :onkeyup="formType.teammoney" style="width: 320px;" v-model="formType.teammoney" placeholder="请输入" maxlength="10"></el-input>
                <span class="tips_span">万元</span>
            </el-form-item>
            <el-form-item label="产品前景评价：">
                <el-input :onkeyup="formType.productmoney" style="width: 320px;" v-model="formType.productmoney" placeholder="请输入" maxlength="10"></el-input>
                <span class="tips_span">万元</span>
            </el-form-item>
            <el-form-item label="盈利模式评价：">
                <el-input :onkeyup="formType.modemoney" style="width: 320px;" v-model="formType.modemoney" placeholder="请输入" maxlength="10"></el-input>
                <span class="tips_span">万元</span>
            </el-form-item>
            <el-form-item label="产品创意评价：">
                <el-input :onkeyup="formType.creativemoney" style="width: 320px;" v-model="formType.creativemoney" placeholder="请输入" maxlength="10"></el-input>
                <span class="tips_span">万元</span>
            </el-form-item>
            <el-form-item label="董事会评价：">
                <el-input :onkeyup="formType.dshmoney" style="width: 320px;" v-model="formType.dshmoney" placeholder="请输入" maxlength="10"></el-input>
                <span class="tips_span">万元</span>
            </el-form-item>
        </el-form>
    </div>
    <!-- end 博克斯模型 -->

    <div v-if="typeValue === 'A06'" class="type type6">
        <el-form :label-position="labelPosition" label-width="220px" :model="formType" class="animated fadeInUp">
            <el-form-item label="所处行业：">
                <el-select @change="tradeChange($event)" v-model="formType.industrycode" style="width: 320px;" placeholder="请输入">
                    <el-option v-for="(item, index) in industryData" :key="index" :label="item.text" :value="item.code"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="上市成功后市盈率：">
                <el-input :onkeyup="formType.pevalue = formType.pevalue.replace(/[^\d.]/g,'')" style="width: 320px;" v-model="formType.pevalue" placeholder="根据行业默认，可以手动改" maxlength="4"></el-input>

                <el-tooltip placement="right">
                    <div class="tooltip_content" slot="content">上一年度平均市盈率</div>
                    <img class="tooltip_icon" :src="require('@/common/images/gujingimgs/icon_tip.png')" alt="">
                </el-tooltip>

            </el-form-item>
            <el-form-item label="净利润：">
                <el-input :onkeyup="formType.netprice" style="width: 320px;" v-model="formType.netprice" placeholder="请输入" maxlength="10"></el-input>
                <span class="tips_span">万元</span>

                <el-tooltip placement="right">
                    <div class="tooltip_content" slot="content">上一年度的净利润</div>
                    <img class="tooltip_icon" :src="require('@/common/images/gujingimgs/icon_tip.png')" alt="">
                </el-tooltip>

            </el-form-item>
            <el-form-item label="投资者要求的年化回报率：">
                <el-input :onkeyup="formType.yearrate" style="width: 320px;" v-model="formType.yearrate" placeholder="请输入" maxlength="6"></el-input>
                <span class="tips_span">%</span>

                <el-tooltip placement="right">
                    <div class="tooltip_content" slot="content">一般在0-50%，优秀企业10年年化回报率不超过30%</div>
                    <img class="tooltip_icon" :src="require('@/common/images/gujingimgs/icon_tip.png')" alt="">
                </el-tooltip>

            </el-form-item>
            <el-form-item label="企业后续融资对股权的稀释比例：">
                <el-input :onkeyup="formType.xsrate = formType.xsrate.replace(/[^\d.]/g,'')" style="width: 320px;" v-model="formType.xsrate" placeholder="请输入" maxlength="5"></el-input>
                <span class="tips_span">%</span>

                <el-tooltip placement="right">
                    <div class="tooltip_content" slot="content">一般在25%或10%（股权超过4亿时可选择）</div>
                    <img class="tooltip_icon" :src="require('@/common/images/gujingimgs/icon_tip.png')" alt="">
                </el-tooltip>

            </el-form-item>
            <el-form-item label="预计上市年限：">
                <el-input :onkeyup="formType.ssyear = formType.ssyear.replace(/[^\d.]/g,'')" style="width: 320px;" v-model="formType.ssyear" placeholder="请输入" maxlength="3"></el-input>
                <span class="tips_span">年</span>
            </el-form-item>
        </el-form>
    </div>
    <!-- end 上市逆推法 -->

    <div class="type" style="padding-top:0">
        <el-form :label-position="labelPosition" label-width="220px" class="animated fadeInUp">
            <el-form-item label="验证码：">
                <el-input style="width: 210px" placeholder="请输入验证码" v-model="usercode" maxlength="4"></el-input>
                <img style=" cursor: pointer;,margin-left:10px; float: right;" @click="getCode" :src="base64"/>
            </el-form-item>
        </el-form>
    </div>
    
    <div class="page-module btnlist animated fadeInUp">
        <el-button @click="upStep" type="primary" plain>上一步</el-button>
        <el-button @click="startAppraisement" type="primary">开始估值</el-button>
    </div>
</div>
</template>

<script>
import $ from 'jquery'
import {getIndustryinfoList, starEvOperation, createCode} from 'api/gujingApi'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'StepThree',
    data() {
        return {
            typeValue: 'A01',
            labelPosition: 'right',
            industryData: [],
            paramsValue: {
                evindustrytype: '',
                evphasetype: '',
                evuseagetype: ''
            },
            usercode: '', // 验证码
            codeEncryption: '', // 验证码密文
            formType: {
                industrycode: '', //行业code
                industryname: '', //行业名称
                pevalue: '', //市盈率
                netprice: '', //净利润-单位万元
                pbvvalue: '', //市净率（P/BV）

                yearcount: '', //预测年数
                basecashmoney: '', //基准自由现金流-万元
                insrate: '', //增长率%
                disrate: '12', //折现率%（R)
                yxinsrate: '', //永续增长率%(g)

                industryk: '', //行业常数K
                incomebyper: '', //单客收入（元）
                activeusercount: '', //月活跃用户（万）
                lifemonth: '', //用户生命周期（月）

                teammoney: '', //团队评价（万元）
                productmoney: '', //产品前景评价（万元）
                modemoney: '', //盈利模式评价（万元）
                creativemoney: '', //产品创意评价（万元）
                dshmoney: '', //董事会评价（万元）

                yearrate: '', //年化回报率%
                xsrate: '', //稀释比例%
                ssyear: '', //预计上市年限（年）
            },
            base64: '',
            integer: /^[1-9]*[1-9][0-9]*$/, // 整数判断正则
            justfolter: /^([-1-9]\d{0,15}|0)(\.\d{1,2})?$/ // 小数判断正则
        }
    },
    mounted() {
        $('html').scrollTop(0)
        this.getCode()
        // this.findIndustryinfoList()
    },
    methods: {
        // 获取验证码
        getCode() {
          this.setLoading(true)
          createCode({
              data: {},
              success: data => {
                   this.setLoading(false)
                   this.base64 = data.result.base64
                   this.codeEncryption = data.result.codeEncryption
                //    console.log(data)
              },
              error: data => {
                  this.setLoading(false)
                  this.$message.error(data.msg)
              }
          })
        },
        // 选择行业改变
        tradeChange(e) {
            // console.log(e)
            for (let index = 0; index < this.industryData.length; index++) {
                if (this.industryData[index].code === e) {
                    this.formType.industryname = this.industryData[index].text
                }
            }
            if (this.typeValue === 'A01') {
                for (let index = 0; index < this.industryData.length; index++) {
                    if (this.industryData[index].code === e) {
                        this.formType.pevalue = this.industryData[index].lastdynsyl
                    }
                }
            }
            if (this.typeValue === 'A02') {
                for (let index = 0; index < this.industryData.length; index++) {
                    if (this.industryData[index].code === e) {
                        this.formType.pbvvalue = this.industryData[index].lastsjl
                    }
                }
            }
            if (this.typeValue === 'A01' || this.typeValue === 'A02' || this.typeValue === 'A04' || this.typeValue === 'A06') {
                for (let index = 0; index < this.industryData.length; index++) {
                    if (this.industryData[index].code === e) {
                        this.formType.industryk = this.industryData[index].industryk
                    }
                }
            }
            if (this.typeValue === 'A06') {
                for (let index = 0; index < this.industryData.length; index++) {
                    if (this.industryData[index].code === e) {
                        this.formType.pevalue = this.industryData[index].lastdynsyl
                    }
                }
            }
        },
        // 获取行业列表
        findIndustryinfoList() {
            this.setLoading(true)
            let params = {}
            getIndustryinfoList({
                data: Object.assign({}, params),
                success: data => {
                    // console.log(data)
                    this.setLoading(false)
                    this.industryData = data.data.content
                },
                error: data => {
                    this.$message.error(data.msg)
                }
            })
        },
        // 设置估值要素的表单类型
        getTypeValue(val) {
            this.typeValue = val
            this.findIndustryinfoList()
            // this.formType = {
                //     industrycode: '', //行业code
                //     industryname: '', //行业名称
                //     pevalue: '', //市盈率
                //     netprice: '', //净利润-单位万元
                //     pbvvalue: '', //市净率（P/BV）

                //     yearcount: '', //预测年数
                //     basecashmoney: '', //基准自由现金流-万元
                //     insrate: '', //增长率%
                //     disrate: '', //折现率%（R)
                //     yxinsrate: '', //永续增长率%(g)

                //     industryk: '', //行业常数K
                //     incomebyper: '', //单客收入（元）
                //     activeusercount: '', //月活跃用户（万）
                //     lifemonth: '', //用户生命周期（月）

                //     teammoney: '', //团队评价（万元）
                //     productmoney: '', //产品前景评价（万元）
                //     modemoney: '', //盈利模式评价（万元）
                //     creativemoney: '', //产品创意评价（万元）
                //     dshmoney: '', //董事会评价（万元）

                //     yearrate: '', //年化回报率%
                //     xsrate: '', //稀释比例%
                //     ssyear: '' //预计上市年限（年）
            // }
        },
        // 设置估值需要的行业参数
        setParamsValue(val) {
            this.paramsValue = val
            // console.log('this.paramsValue:', this.paramsValue)
        },
        // 上一步
        upStep() {
            this.$emit('setStepValue', 1)
            // 清空数据
            // this.formType = {
            //     industrycode: '', //行业code
            //     industryname: '', //行业名称
            //     pevalue: '', //市盈率
            //     netprice: '', //净利润-单位万元
            //     pbvvalue: '', //市净率（P/BV）

            //     yearcount: '', //预测年数
            //     basecashmoney: '', //基准自由现金流-万元
            //     insrate: '', //增长率%
            //     disrate: '', //折现率%（R)
            //     yxinsrate: '', //永续增长率%(g)

            //     industryk: '', //行业常数K
            //     incomebyper: '', //单客收入（元）
            //     activeusercount: '', //月活跃用户（万）
            //     lifemonth: '', //用户生命周期（月）

            //     teammoney: '', //团队评价（万元）
            //     productmoney: '', //产品前景评价（万元）
            //     modemoney: '', //盈利模式评价（万元）
            //     creativemoney: '', //产品创意评价（万元）
            //     dshmoney: '', //董事会评价（万元）

            //     yearrate: '', //年化回报率%
            //     xsrate: '', //稀释比例%
            //     ssyear: '', //预计上市年限（年）
            // }
            // // 验证码修改
            // this.getCode()
        },
        // 开始估值
        startAppraisement() {
            // console.log('this.paramsValue:', this.paramsValue)
            if (this.typeValue == 'A01' || this.typeValue == 'A02') {
                if (this.formType.industrycode === '') {
                    this.$message.warning('请选择所处行业')
                    return
                }
                if (this.typeValue == 'A01') {
                    if (this.formType.pevalue === '') {
                        this.$message.warning('请输入市盈率')
                        return
                    }
                    if (this.formType.pevalue < 0 || this.formType.pevalue > 1000 || !this.justfolter.test(this.formType.pevalue)) {
                        this.$message.warning('市盈率请在0 - 1000之间, 且最多为两位小数')
                        return
                    }

                }
                if (this.typeValue === 'A02') {
                    if (this.formType.pbvvalue === '') {
                        this.$message.warning('请输入市净率')
                        return
                    }
                    console.log(this.justfolter.test(this.formType.pbvvalue))
                    if (this.formType.pbvvalue < 0 || this.formType.pbvvalue > 1000 || !this.justfolter.test(this.formType.pbvvalue)) {
                        this.$message.warning('市净率请在0 - 1000之间, 且最多为两位小数')
                        return
                    }
                    
                }
                if (this.formType.netprice === '') {
                    if (this.typeValue === 'A01') {
                        this.$message.warning('请输入净利润')
                    } else {
                        this.$message.warning('请输入净资产')
                    }
                    return
                }
                if (this.formType.netprice < -10000000 || this.formType.netprice > 10000000) {
                    if (this.typeValue === 'A01') {
                        this.$message.warning('净利润请在-10000000 - 10000000之间')
                    } else {
                        this.$message.warning('净资产请在-10000000 - 10000000之间')
                    }
                    return
                }
            }
            if (this.typeValue === 'A03') {
                if (this.formType.yearcount === '') {
                    this.$message.warning('请输入预测年数')
                    return
                }
                if (!this.integer.test(this.formType.yearcount)) {
                    this.$message.warning('预测年数请为非0整数')
                    return
                }
                if (this.formType.yearcount < 1 || this.formType.yearcount > 100) {
                    this.$message.warning('预测年数请在1 - 100之间')
                    return
                }
                if (this.formType.basecashmoney === '') {
                    this.$message.warning('请输入基准自由现金流')
                    return
                }
                if (this.formType.basecashmoney < 0 || this.formType.basecashmoney > 10000000) {
                    this.$message.warning('基准自由现金流请在0 - 10000000之间')
                    return
                }
                if (this.formType.insrate === '') {
                    this.$message.warning('请输入增长率')
                    return
                }
                if (this.formType.insrate < -1000 || this.formType.insrate > 1000 || !(this.justfolter.test(this.formType.insrate))) {
                    this.$message.warning('增长率请在-1000 - 1000之间，且最多为两位小数')
                    return
                }
                if (this.formType.disrate === '') {
                    this.$message.warning('请输入折现率')
                    return
                }
                if (this.formType.disrate < 0 || this.formType.disrate > 24 || !(this.justfolter.test(this.formType.disrate))) {
                    this.$message.warning('折现率请在0 - 24之间，且最多为两位小数')
                    return
                }
                if (this.formType.yxinsrate === '') {
                    this.$message.warning('请输入永续增长率')
                    return
                }
                if (this.formType.yxinsrate < -100 || this.formType.yxinsrate > 100 || !(this.justfolter.test(this.formType.yxinsrate))) {
                    this.$message.warning('永续增长率请在-100 - 100之间，且最多为两位小数')
                    return
                }
                if (this.formType.disrate == this.formType.yxinsrate){
                    this.$message.warning('折现率和永续增长率不能相等')
                    return
                }
                
            }
            if (this.typeValue === 'A04') {
                if (this.formType.industrycode === '') {
                    this.$message.warning('请选择所处行业')
                    return
                }
                if (this.formType.incomebyper === '') {
                    this.$message.warning('请输入单客收入')
                    return
                }
                if (this.formType.incomebyper < 0 || this.formType.incomebyper > 100000000) {
                    this.$message.warning('单客收入请在0 - 100000000之间')
                    return
                }
                if (this.formType.activeusercount === '') {
                    this.$message.warning('请输入月活跃用户')
                    return
                }
                if (this.formType.activeusercount < 0 || this.formType.activeusercount > 1000000) {
                    this.$message.warning('月活跃用户请在0 - 1000000')
                    return
                }
                if (this.formType.lifemonth === '') {
                    this.$message.warning('请输入用户生命周期')
                    return
                }
                if (!this.integer.test(this.formType.lifemonth)) {
                    this.$message.warning('用户生命周期请为非0整数')
                    return
                }
                if (this.formType.lifemonth < 0 || this.formType.lifemonth > 1000) {
                    this.$message.warning('用户生命周期请在1 - 1000')
                    return
                }
            }
            if (this.typeValue === 'A05') {
                if (this.formType.teammoney === '') {
                    this.$message.warning('请输入团队评价')
                    return
                }
                if (this.formType.teammoney < -1000000 || this.formType.teammoney > 1000000 || !(this.justfolter.test(this.formType.teammoney))) {
                    this.$message.warning('团队评价请在-1000000 - 1000000之间，且最多为两位小数')
                    return
                }
                if (this.formType.productmoney === '') {
                    this.$message.warning('请输入产品前景评价')
                    return
                }
                if (this.formType.productmoney < -1000000 || this.formType.productmoney > 1000000 || !(this.justfolter.test(this.formType.productmoney))) {
                    this.$message.warning('产品前景评价请在-1000000 - 1000000之间，且最多为两位小数')
                    return
                }
                if (this.formType.modemoney === '') {
                    this.$message.warning('请输入盈利模式评价')
                    return
                }
                if (this.formType.modemoney < -1000000 || this.formType.modemoney > 1000000 || !(this.justfolter.test(this.formType.modemoney))) {
                    this.$message.warning('盈利模式评价请在-1000000 - 1000000之间，且最多为两位小数')
                    return
                }
                if (this.formType.creativemoney === '') {
                    this.$message.warning('请输入产品创意评价')
                    return
                }
                if (this.formType.creativemoney < -1000000 || this.formType.creativemoney > 1000000 || !(this.justfolter.test(this.formType.creativemoney))) {
                    this.$message.warning('产品创意评价请在-1000000 - 1000000之间，且最多为两位小数')
                    return
                }
                if (this.formType.dshmoney === '') {
                    this.$message.warning('请输入董事会评价')
                    return
                }
                if (this.formType.dshmoney < -1000000 || this.formType.dshmoney > 1000000 || !(this.justfolter.test(this.formType.dshmoney))) {
                    this.$message.warning('董事会评价请在-1000000 - 1000000之间，且最多为两位小数')
                    return
                }
            }
            if (this.typeValue === 'A06') {
                if (this.formType.industrycode === '') {
                    this.$message.warning('请选择所处行业')
                    return
                }
                if (this.formType.pevalue === '') {
                    this.$message.warning('请输入上市成功后市盈率')
                    return
                }
                if (this.formType.netprice === '') {
                    this.$message.warning('请输入净利润')
                    return
                }
                if (this.formType.netprice < -1000000 || this.formType.netprice > 1000000 || !(this.justfolter.test(this.formType.netprice))) {
                    this.$message.warning('净利润请在-1000000 - 1000000之间，且最多为两位小数')
                    return
                }
                if (this.formType.yearrate === '') {
                    this.$message.warning('请输入投资者要求的年化回报率')
                    return
                }
                if (this.formType.yearrate < -100 || this.formType.yearrate > 100 || !(this.justfolter.test(this.formType.yearrate))) {
                    this.$message.warning('投资者要求的年化回报率请在-100 - 100之间，且最多为两位小数')
                    return
                }
                if (this.formType.xsrate === '') {
                    this.$message.warning('请输入企业后续融资对股权的稀释比例')
                    return
                }
                if (this.formType.xsrate < 0 || this.formType.xsrate > 100 || !(this.justfolter.test(this.formType.xsrate))) {
                    this.$message.warning('企业后续融资对股权的稀释比例请在0 - 100之间，且最多为两位小数')
                    return
                }
                if (this.formType.ssyear === '') {
                    this.$message.warning('请输入预计上市年限')
                    return
                }
                if (!(this.integer.test(this.formType.ssyear))) {
                    this.$message.warning('预计上市年限请为非0整数')
                    return
                }
                if (this.formType.ssyear < 1 || this.formType.ssyear > 100) {
                    this.$message.warning('预计上市年限请在1 - 100之间')
                    return
                }
            }

            if (this.usercode.length == 0) {
                this.$message.warning('请输入验证码')
                return
            }
            console.log(this.codeEncryption)
            this.starEvOperationFn()
        },
        starEvOperationFn() {
            this.setLoading(true)
            let params = {
                code: this.typeValue,
                codeEncryption: this.codeEncryption,
                usercode: this.usercode,
                importinfo: JSON.stringify(this.formType)
            }
            starEvOperation({
                data: Object.assign({}, params, this.paramsValue),
                success: data => {
                    // console.log(data)
                    this.setLoading(false)
                    if (data) {
                        this.$emit('setStepValue', 3)
                        this.$emit('setResultData', data.data)
                    }
                },
                error: data => {
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss">
.StepThree {
    background-color: #fff;
    width: 1200px;
    margin: 0 auto;
    .btnlist {
        margin-top: 60px;
    }
    .type {
        padding-left: 266px;
        padding-top: 50px;
        // padding-bottom: 60px;
        // display: flex;
        // align-items: center;
        // justify-content: center;
        .el-form {
            .el-form-item:nth-last-of-type(1) {
                margin-bottom: 0;
            }
            .el-form-item__content {
                position: relative;
                display: flex;
                align-items: center;
                .el-input__inner {
                    padding-right: 40px;
                }
                .tips_span {
                    color: #666;
                    position: absolute;
                    top: 0;
                    right: 402px;
                }
                .tooltip_icon {
                    margin-left: 10px;
                    width: 14px;
                    height: 14px;
                    cursor: pointer;
                }
            }
        }
        .el-form-item__label {
            white-space: nowrap;
        }
    }
}
</style>
<style>
    .tooltip_content{
        color: #666;
        /* text-align: center; */
        padding: 5px 10px;
        line-height: 20px;
        font-size: 14px;
    }
    .el-tooltip__popper.is-dark{
        background: #FFF;
        box-shadow:0px 0px 12px 0px rgba(0,0,0,0.06);
    }
    .el-tooltip__popper{
        padding: 5px;
    }
    .el-tooltip__popper .popper__arrow, .el-tooltip__popper .popper__arrow::after{
        border-right-color: #FFF !important
    }
</style>